// @mui
import { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { forwardRef, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

interface Props extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
}

/**
 * @deprecated has been removed in Minimal@4. You can use it but have to maintain it yourself.
 */
const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', meta, ...other }, ref) => (
  <>
    <Helmet>
      <title>{`${title} | Predium`}</title>
      {meta}
    </Helmet>

    <Box ref={ref} {...other}>
      {children}
    </Box>
  </>
));

export default Page;
